// jsaForm/state.js

import { v4 as uuidv4 } from "uuid";

// Autosave error tracking state for JSA form
// Mirrors the DEL form pattern for consistency
export const jsaAutosaveErrorsInitialState = {
  hasErrors: false,
  lastError: null, // { key, message, timestamp, patchType, rowId? }
  fieldErrors: {}, // { "jsa_basic_info.site_location": "Site Location is required" }
  rowErrors: {}, // { "signature_uuid123": { employee_id: "Required" } }
};

// Core state
export const jsaCoreInitialState = {
  basicInfo: {
    googleSessionToken: uuidv4(),
    useAddressValidation: true,
  },
  racInfo: {},
  trainingInfo: {
    // showTrainingInfo and showEwiTrainerInput removed - now derived from data model
  },
  signatureInfo: {
    jsaActiveSignatureTab: "Employee Signatures",
    signatureModalOpen: false,
    currentSignee: null,
    currentSignatureImage: null,
  },
};

// V1 state
export const jsaV1InitialState = {
  confinedSpace: {
    showCseEntrySection: false,
    showCseBreakingPlaneSection: false,
    showCsePermitClientSection: false,
    showAdminNotifiedSection: false,
  },
  emergencyEquipment: {},
  fallProtection: {
    showFallProtectionSection: false,
  },
  hazCom: {
    showHazComSection: false,
  },
  permits: {},
  ppe: {
    showJsaPpeHandOtherSection: false,
    showJsaPpeFootOtherSection: false,
    showJsaPpeRespiratorySection: false,
  },
};

// V2 state
export const jsaV2InitialState = {
  hazards: {
    showOtherHazDescribe: false,
  },
  controlMeasures: {
    showCseSection: false,
    showElectricalSection: false,
    showEquipmentSection: false,
    showExcavationSection: false,
    showFallProtectionSection: false,
    showFireProtectionSection: false,
    showHandToolsSection: false,
    showHeatColdStressSection: false,
    showInspectionsSection: false,
    showMedicalSection: false,
    showPermitsSection: false,
    showPpeSection: false,
    showPopSection: false,
    showTrainingSection: false,
    showVehicleTrafficSection: false,
    showWeldingCuttingSection: false,
  },
};

// JSA State
export const jsaFormInitialState = {
  base: {
    activeJsaTab: "All",
    // Flag to indicate if JSA is embedded in another form (DEL, Sampling Event, etc.)
    // When true, patches are wrapped for parent form's socket service routing
    // When false, JSA uses its own standalone socket service
    isEmbeddedInForm: false,
  },
  core: jsaCoreInitialState,
  v1: jsaV1InitialState,
  v2: jsaV2InitialState,
  autosaveErrors: jsaAutosaveErrorsInitialState,
};
